module.exports = __webpack_public_path__ + "static/media/208.853b6205.jpg";